module.exports = {"API-ENDPOINT":"https://services.myanatomy.in:8443"}


//////////////////
// WEBPACK FOOTER
// ./src/conf/config-prod.json
// module id = 587
// module chunks = 0